import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { retry } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { ApiResponse } from '@app/_models';

@Injectable({ providedIn: 'root' })
export class TaskServiceDetailService {

  urlEndpoint = 'task-service-details';

  constructor(private http: HttpClient) {}

  findById(id: number): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}`).pipe(retry({ count: 2, delay: 1500 }));
  }

  findByTaskId(taskId: number): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/task/${taskId}`).pipe(retry({ count: 2, delay: 1500 }));
  }

  /**
   * Rollup endpoint for the Service Detail Rollup View.
   * TODO: Backend endpoint GET /api/2.6/task-service-details/rollup is not yet implemented.
   * Until it lands, the Service Detail Rollup page stubs with sample data.
   */
  getRollup(startDate: string, endDate: string, region?: number, propertyIds?: number[], serviceTag?: string): Observable<ApiResponse> {
    let params = new HttpParams()
      .set('startDate', startDate)
      .set('endDate', endDate);
    if (region) { params = params.set('region', String(region)); }
    if (propertyIds && propertyIds.length) { params = params.set('propertyIds', propertyIds.join(',')); }
    if (serviceTag) { params = params.set('serviceTag', serviceTag); }
    return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/rollup`, { params }).pipe(retry({ count: 2, delay: 1500 }));
  }
}
